import { put, take, takeEvery } from 'redux-saga/effects'

import { UPDATE_GEONAME_INFO, resetLocation } from '@bikemap/js/integrations/geolocation'
import { MAP_MOVE, MAP_ZOOM } from '@bikemap/js/integrations/map/actions'

function* resetLocationOnNextBoundsChange() {
    yield take([MAP_MOVE, MAP_ZOOM])
    yield put(resetLocation())
}

/**
 * Resets geolocation when the user moves the map.
 */
export default function* geolocationResetSaga() {
    // When search is related to a geoname
    yield takeEvery(UPDATE_GEONAME_INFO, resetLocationOnNextBoundsChange)
}
